var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.logoClasses},[_c('logo-alt-image',{staticClass:"logo__image"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }